import { Icon } from "@sellar-io/components";

export const DeliveryInstructionAlert = () => {
  return (
    <div className="flex items-center gap-2">
      <Icon icon="ALERT" className="text-zinc-700" size={0.65} />
      <p className="text-zinc-500">
        This field is for internal purposes only and cannot be shared with
        couriers.
      </p>
    </div>
  );
};
